import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/** CB-148 — gate the `/v2/...` Regimen & Order Set screens behind the `regimenOrderSetV2` flag. When off, the
 *  routes resolve to nothing and the user is sent to the existing Regimens screen. */
export const regimenOrderSetV2Guard: CanActivateFn = () => {
    if (environment.regimenOrderSetV2) {
        return true;
    }
    return inject(Router).createUrlTree(['/regimens']);
};
